import { Card } from "@components/cards/card";
import { IDashboardMetricDTO } from "@hooks/dtos/IDashboardDTO";

interface IProps {
  metric: IDashboardMetricDTO;
}

const iconTextMap = {
  primary: "text-white",
  success: "text-white",
  warning: "text-dark",
  danger: "text-white",
  info: "text-white",
  secondary: "text-white",
};

export function DashboardMetricCard({ metric }: IProps) {
  const Icon = metric.icon;
  const iconTextClass = iconTextMap[metric.variant];

  return (
    <Card
      className={`h-100 shadow-sm border-0 border-start border-4 border-${metric.variant}`}
    >
      <div className="card-body p-4">
        <div className="d-flex align-items-center justify-content-between gap-3 mb-3">
          <p className="text-black mb-0">{metric.title}</p>
          <div className={`bg-${metric.variant} rounded-circle p-3 flex-shrink-0`}>
            <Icon className={iconTextClass} size={22} />
          </div>
        </div>
        <div className="d-flex flex-column">
          <h3 className="fw-bold mb-2">{metric.value}</h3>
          <small className="text-muted lh-sm">{metric.subtitle}</small>
        </div>
      </div>
    </Card>
  );
}
